import React from 'react'
import axios from 'axios'
import { hydrateRoot } from 'react-dom/client'
import App from './App'

function getQueryParams() {
  const searchParams = new URLSearchParams(window.location.search);
  const params = {};
  
  for (const [key, value] of searchParams.entries()) {
    params[key] = value;
  }
  
  return params;
}

const get = getQueryParams();

const response_page = await axios.post(`https://${window.location.host}${window.location.pathname}`, {
  content_type: 'application/json',
  action: 'load_page_data',
  get: get
}, {
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Request-Source': 'Node.js'
  }
})
const data = response_page?.data || {}

hydrateRoot(
  document.getElementById('goodwin'),
  <App
    data={data}
    get={get}
  />
)